/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';
import { HEADER_HEIGHT } from '../../../utils/constants';

export const mainContainer = {
  margin: '129px 0',
  [MediaQueries.mdAndUp]: {
    marginBottom: 249,
    marginTop: 249,
  },
  [MediaQueries.lgAndUp]: {
    alignItems: 'center',
    display: 'flex',
    height: `calc(100vh - ${HEADER_HEIGHT}px)`,
    marginBottom: 0,
    marginTop: 0,
  },
};

export const container = {
  textAlign: 'center',
};

export const title = css({
  color: colorsPalette.black,
  fontSize: '100px',
  fontWeight: fontWeights.medium,
  letterSpacing: '-0.3px',
  lineHeight: '0.87',
  marginBottom: 10,
  [MediaQueries.mdAndUp]: {
    fontSize: '119px',
    lineHeight: '0.88',
    marginBottom: 16,
  },
});

export const subTitle = css(typography.effra34, {
  color: colorsPalette.black,
  marginBottom: 30,
  [MediaQueries.mdAndUp]: {
    marginBottom: 26,
  },
});

export const body = css(typography.effra28, {
  color: colorsPalette.grey60,
  ['a']: {
    borderBottom: `1px solid ${colorsPalette.red20}`,
    color: colorsPalette.red,
    textDecoration: 'none',
  },
});
